import type { ToT } from "@/route-types";
import type { FormViewT, PageViewT } from "@/types/database/forms";
import type { NextEntryT } from "@/types/database/trackers";
import useObservationFormPage from "../hooks/useObservationFormPage";
import FormPage from "./FormPage";

interface Props {
	route: ToT;
	pageIndex: number;
	form: FormViewT;
	nextEntry?: NextEntryT;
	diaryId?: string;
	patientId: string;
}

const ObservationFormPage = (props: Props) => {
	// Find the current page with proper typing
	const currentPage = props.form?.pages?.find(
		(p) => Number((p as PageViewT)?.page_index) === Number(props?.pageIndex),
	) as PageViewT | undefined;

	const { form, onSubmit, prevPage, nextPage } = useObservationFormPage({
		route: props.route.to,
		pageCount: props.form?.pages?.length || 0,
		inputs: currentPage?.inputs || [],
		nextEntry: props.nextEntry || null,
		patientId: props.patientId,
	});

	return (
		<FormPage
			route={props.route}
			pageIndex={props.pageIndex}
			form={props.form}
			nextEntry={props.nextEntry}
			diaryId={props.diaryId}
			formType="observation"
			reactHookForm={form}
			onSubmit={onSubmit}
			prevPage={prevPage}
			nextPage={nextPage}
		/>
	);
};

export default ObservationFormPage;
